import { AgentActivity, KnowledgeBaseArticleWithScore, TicketDetails } from 'src/services/ai-tester.service';

export const AI_CONVERSATION_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
  TOOL: 'tool',
} as const;

export type AIConversationRole = (typeof AI_CONVERSATION_ROLES)[keyof typeof AI_CONVERSATION_ROLES];

export interface AIConversationMessage {
  role: AIConversationRole;
  content: string;
}

export interface SendMessageRequest {
  agent: string;
  history?: AIConversationMessage[];
  impersonatedUserId?: string;
  customerId?: string;
}

// AI Tester-Facing AgentActivity
export interface AITesterAgentActivity extends AgentActivity {
  showThoughtAspects: boolean;
}

// AI Tester-Facing Message. This is a formatted version of AgentMessage
export interface AITesterMessage extends AIConversationMessage {
  timestamp: string;
  suggestedTicketDetails?: TicketDetails;
  citations?: KnowledgeBaseArticleWithScore[];
  formattedThoughts?: AITesterAgentActivity[];
  aiThoughtsShowLowConfidence?: boolean;
}

export const AGENT_CONFIDENCE_THRESHOLD = 70;
